import { LookupOfSystemInt32 } from '../../generated/auth/models/Sasfin/Wealth/Online/BL/Models/lookup-of-system-int-32';

export interface IInvestmentObjectivesState {
  investmentObjectives: LookupOfSystemInt32[];
  loading: boolean;
}

export const initialUIState: IInvestmentObjectivesState = {
  investmentObjectives: [],
  loading: false,
};
